"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupTitle = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const context_1 = require("../context");
const Breadcrumbs_1 = require("../../../../3-list-item/Breadcrumbs");
const ContextSection_1 = require("../../ContextSection");
const use_t_1 = require("use-t");
const GroupTitle = ({ path, off = 0 }) => {
    const [t] = (0, use_t_1.useT)();
    const state = (0, context_1.useContextMenu)();
    const crumbs = [];
    for (let i = off; i < path.length; i++) {
        const item = path[i];
        crumbs.push(React.createElement(Breadcrumbs_1.Breadcrumb, { key: item.id ?? item.name, compact: true, onClick: () => state.select(path.slice(0, i), path[i]) }, t(item.name)));
    }
    return (React.createElement(ContextSection_1.ContextSection, { compact: true },
        React.createElement(Breadcrumbs_1.Breadcrumbs, { compact: true, crumbs: crumbs, style: { padding: '0 0 0 2px' } })));
};
exports.GroupTitle = GroupTitle;
